import { useState } from 'react';
import { NJButton, NJHeading, NJText } from '@engie-group/fluid-design-system-react';
import { UMFormGroup, UMFormStyles, UMInput } from '../../urbanmap/_components';
import type { DevelopmentPlan } from './plans.types';

interface Props {
  plans: DevelopmentPlan[];
  pending: boolean;
  serverError: string | null;
  onSubmit: (name: string) => void;
  onCancel: () => void;
}

/** Nom obligatoire et unique dans le projet ; le plan s'ouvre ensuite sur l'étape Bâtiments. */
export function PlanCreateForm({ plans, pending, serverError, onSubmit, onCancel }: Props) {
  const [name, setName] = useState('');
  const [touched, setTouched] = useState(false);
  const trimmed = name.trim();
  const duplicate = plans.some((p) => p.name.toLowerCase() === trimmed.toLowerCase());
  const error = !trimmed ? 'Le nom du plan est obligatoire.' : duplicate ? 'Un plan porte déjà ce nom dans ce projet.' : null;

  return (
    <form className="pnv2-dp-create" aria-label="Nouveau plan de développement"
      onSubmit={(e) => { e.preventDefault(); setTouched(true); if (!error) onSubmit(trimmed); }}>
      <UMFormStyles />
      <NJHeading as="h3" scale="xs">Nouveau plan de développement</NJHeading>
      <fieldset className="pnv2-dp-fieldset" disabled={pending}>
        <UMFormGroup label="Nom du plan">
          <UMInput value={name} ariaLabel="Nom du plan" placeholder="Ex. Extension vers la gare"
            onChange={(v) => { setName(v); setTouched(true); }} />
        </UMFormGroup>
        {touched && error && <NJText role="alert" scale="xs" className="pnv2-dp-error">{error}</NJText>}
        {serverError && <NJText role="alert" scale="xs" className="pnv2-dp-error">{serverError}</NJText>}
        <NJText scale="xs" className="pnv2-dp-muted">Vous choisirez ensuite les bâtiments, puis le tracé et le phasage.</NJText>
      </fieldset>
      <div className="pnv2-dp-actions">
        <NJButton label="Annuler" variant="secondary" scale="sm" type="button" disabled={pending} onClick={onCancel} />
        <NJButton label={pending ? 'Création…' : 'Créer le plan'} scale="sm" type="submit" disabled={pending || (touched && !!error)} />
      </div>
    </form>
  );
}
